    <template>
    <ValidationObserver ref="observer">
        <b-row>
            <b-col>
                <component-header
                    title="Edit Privacy Setting"
                    :isLoading="loading"
                    :hasback="true"
                    :hasSearch="false"
                    :hasCreate="false"
                    :hasReload="false"
                    backButtonText="Back"
                    @back-press="backBtn"
                />
                <b-card>
                    <div class="selections mb-2">
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="app"
                        >
                            <div
                                class="d-flex flex-column flex-md-row align-items-md-center mb-3 mr-2"
                            >
                                <label class="mr-2">Select App:</label>
                                <b-form-select
                                    v-model="selectedScope"
                                    placeholder="Select App"
                                    :options="scopeOptions"
                                    class="w-auto"
                                ></b-form-select>
                            </div>
                            <span class="validate-error" style="color: red">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="page"
                        >
                            <div
                                class="d-flex flex-column flex-md-row align-items-md-center mb-3"
                            >
                                <label class="mr-2">Select Type:</label>
                                <b-form-select
                                    v-model="selectedType"
                                    :options="typeOptions"
                                    class="w-auto"
                                ></b-form-select>
                            </div>
                            <span class="validate-error" style="color: red">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </div>
                    <b-form-group>
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="title"
                        >
                            <b-form-input
                                v-model="title"
                                placeholder="Enter Title"
                            ></b-form-input>
                            <span class="validate-error" style="color: red">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-form-group>
                </b-card>

                <b-card
                    v-for="(section, index) in subSections"
                    :key="section.id"
                    class="sub-section-card"
                >
                    <div>
                        <div
                            class="d-flex justify-content-between align-items-center mb-2"
                        >
                            <label>
                                Sub Section {{ index + 1 }}
                                <span v-if="index === 0" class="text-muted">
                                    (By Default)
                                </span>
                            </label>
                            <div class="button-group">
                                <b-button
                                    v-if="index > 0"
                                    variant="link"
                                    class="p-0"
                                    @click="removeSubSection(index)"
                                >
                                    <span
                                        class="fa fa-minus-circle fa-2x text-danger"
                                    ></span>
                                </b-button>
                                <b-button
                                    variant="link"
                                    class="p-0"
                                    @click="addSubSection"
                                >
                                    <span
                                        class="fa fa-plus-circle fa-2x text-success"
                                    ></span>
                                </b-button>
                            </div>
                        </div>

                        <b-form-group>
                            <ValidationProvider
                                rules="required"
                                v-slot="{ errors }"
                                name="sub title"
                            >
                                <b-form-input
                                    v-model="section.title"
                                    placeholder="Enter Title"
                                ></b-form-input>
                                <span class="validate-error" style="color: red">{{
                                    errors[0]
                                }}</span>
                            </ValidationProvider>
                        </b-form-group>
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="content"
                        >
                            <vue-editor
                                v-model="section.content"
                                class="mb-3"
                            ></vue-editor>
                            <span class="validate-error" style="color: red">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </div>
                </b-card>

                <div
                    class="buttons d-flex justify-content-center gap-2 mb-4 mt-4"
                >
                    <b-button
                        variant="danger"
                        class="save-btn mr-2"
                        @click="backBtn"
                    >
                        CANCEL
                    </b-button>
                    <b-button
                        variant="primary"
                        class="save-btn"
                        @click="update"
                    >
                        UPDATE
                    </b-button>
                </div>
            </b-col>
        </b-row>
    </ValidationObserver>
</template>

<script>
import { VueEditor } from "vue2-editor";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters } from "vuex";
import ComponentHeader from "@/components/componentNewHeader";

export default {
    name: "EditPrivacySetting",
    components: {
        VueEditor,
        ComponentHeader,
        ValidationProvider,
        ValidationObserver,
    },
    props: ["id", "userData"],
    data() {
        return {
            loading: false,
            selectedType: null,
            selectedScope: null,
            title: "",
            subSections: [{ id: Date.now(), title: "", content: "" }],
            typeOptions: [
                { value: null, text: "Select Type" },
                { value: "termsCondition", text: "Terms & Conditions" },
                { value: "privacyPolicy", text: "Privacy Policy" },
                { value: "aboutUs", text: "About Us" },
            ],
            scopeOptions: [
                { value: null, text: "Select App" },
                { value: "customer", text: "Customer" },
                { value: "seller", text: "Seller" },
                { value: "agent", text: "Agent" },
            ],
        };
    },
    computed: {
        ...mapGetters({
            editPrivacySettingData: "privacySetting/GetEditPrivacySettingData",
        }),
    },
    async mounted() {
        const privacyItem = this.$route.params.data;
        await this.loadPrivacySetting(privacyItem);
        this.populateFormFromStore();
    },
    methods: {
        backBtn() {
            this.$router.push({ path: "/privacy-setting/" });
        },
        populateFormFromStore() {
            const data = this.editPrivacySettingData;
            if (!data) return;

            const sections = (data.sections || []).map((section) => ({
                id: Date.now() + Math.random(),
                title: section.subtitle || "",
                content: section.description || "",
            }));
            this.subSections =
                sections.length > 0
                    ? sections
                    : [{ id: Date.now(), title: "", content: "" }];
            this.title = data.title;
            this.selectedScope = data.scope;
            this.selectedType = data.content;
        },
        async loadPrivacySetting(privacyItem) {
            try {
                const payload = {
                    tenant: privacyItem.tenant || this.$currentUserData._id,
                    content: privacyItem.content,
                    slug: privacyItem.scope,
                };
                await this.$store.dispatch(
                    "privacySetting/viewPrivacySettingAction",
                    payload
                );
            } catch (error) {
                console.error("Error loading privacy setting:", error);
            }
        },
        addSubSection() {
            this.subSections.push({
                id: Date.now() + Math.random(),
                title: "",
                content: "",
            });
        },
        removeSubSection(index) {
            if (this.subSections.length > 1) {
                this.subSections.splice(index, 1);
            }
        },
        async update() {
            const isValid = await this.$refs.observer.validate();
            if (!isValid) return;

            const sections = this.subSections.map((section) => ({
                subtitle: section.title,
                description: section.content,
            }));

            const data = {
                id: this.$route.params.data._id,
                data: {
                    tenant: this.$currentUserData._id,
                    sections: sections,
                    title: this.title,
                    slug: this.title
                        .toLowerCase()
                        .trim()
                        .replace(/\s+/g, "-")
                        .replace(/[^\w\-]+/g, "")
                        .replace(/\-\-+/g, "-"),
                    content: this.selectedType,
                    scope: this.selectedScope,
                },
            };

            try {
                await this.$store.dispatch(
                    "privacySetting/editPrivacySettingAction",
                    data
                );
                this.$swal({
                    title: "Success",
                    text: "Privacy setting updated successfully!!",
                    type: "success",
                });
                this.$router.push({ path: "/privacy-setting/" });
            } catch (error) {
                this.$swal({
                    title: "Error",
                    text: "Failed to update privacy setting",
                    type: "error",
                });
            }
        },
    },
};
</script>

<style>
.selections {
    display: flex;
    flex-direction: column;
}

@media (min-width: 768px) {
    .selections {
        flex-direction: row;
        justify-content: flex-start;
    }
}

.type-selection,
.scope-selection {
    display: flex;
    align-items: center;
}

.button-group {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.buttons {
    width: 50%;
    padding-bottom: 30px;
    margin: 0 auto;
}

.sub-section-card {
    margin-top: 20px;
}
</style>
